module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_10_100.35207e6a.png";